import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { SCENE_POST_MESSAGE_TYPES } from '../constants/postMessageTypes';
import { SCENE_QUERY_KEYS } from '@pocapan/shared/domains/scene/ui/queryKeys';
import type { InfiniteData } from 'react-query';
import type { AdaptedFictionPreviewResponse } from '@pocapan/shared/domains/scene/services/sceneService';

type InfiniteAdaptedFictionPreviews = InfiniteData<AdaptedFictionPreviewResponse>;

export const useDeleteSceneCommentMessage = () => {
  const queryClient = useQueryClient();
  useEffect(() => {
    const handleMessage = (
      event: MessageEvent<{ type: string; params: { adaptedFictionPreviewId: string } }>
    ) => {
      if (event.data.type === SCENE_POST_MESSAGE_TYPES.DELETE_SCENE_COMMENT) {
        const { adaptedFictionPreviewId } = event.data.params;
        queryClient.setQueriesData<InfiniteAdaptedFictionPreviews>(
          SCENE_QUERY_KEYS.adaptedFictionPreviews,
          (old) => {
            if (!old) return old as unknown as InfiniteAdaptedFictionPreviews;
            return {
              ...old,
              pages: old.pages.map((page) => {
                return page.map((post) => {
                  if (post.adaptedFictionPreviewId === adaptedFictionPreviewId) {
                    return {
                      ...post,
                      commentsCount: Math.max(0, (post.commentsCount ?? 0) - 1)
                    };
                  }
                  return post;
                });
              })
            };
          }
        );
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [queryClient]);
};
